<div class="department-container" *ngIf="!isLoadingLabels && !isLoadingDepartment">
	<div class="search" *ngIf="customDepartment.id == undefined">
		<cpi-input-with-autocomplete
			[availableOptions]="listDepartmentIAC"
			[minInputLength]="0"
			[cleanValues]="clearValuesDepartment"
			[placeholder]="labels.lbl_selecione_departamento"
			[keepValue]="false"
			(onValueChange)="getDepartment($event)"
			*ngIf="!isLoadingDepartment">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			[header]="searchHeader"
			[body]="departmentList"
			[height]="'48dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="getDepartment($event[0]['id'])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_gerar_novo_department }}</div>
		</div>
	</div>

	<ng-container *ngIf="customDepartment.id != undefined">
		<div class="header-wrap">
			<span class="tab selected">{{ labels.lbl_geral_departamentos }}</span>
		</div>
		<div class="body-wrap">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_depto }} *</span>
				<input type="text" [value]="customDepartment.department" (input)="customDepartment.department = $event.target.value" />
			</div>

			<div class="dotted-input-container" *ngIf="this.userVisible === true">
				<span>{{ labels.lbl_geral_responsavel_departmento }}</span>
				<cpi-input-with-autocomplete
					[availableOptions]="listResponsibleIAC"
					[minInputLength]="0"
					[cleanValues]="clearValuesResponsible"
					[setInputText]="customDepartment.responsible"
					[setValue]="customDepartment.idFull_Name"
					[placeholder]="labels.lbl_selecione_departamento"
					(onValueChange)="getResponsible($event)"
					*ngIf="!isLoadingResponsible">
				</cpi-input-with-autocomplete>
			</div>

			<div *ngIf="this.userVisible === true">
				<span>{{ labels.lbl_geral_usuario_departmento }}</span>

				<div class="table-container">
					<table>
						<thead>
							<tr>
								<th>{{ labels.lbl_geral_nome_completo }}</th>
								<th>{{ labels.lbl_email_completo }}</th>
							</tr>
						</thead>
						<tbody>
							<ng-container>
								<tr class="select-bond" *ngFor="let item of customDepartment.items">
									<td>{{ item.full_name }}</td>
									<td>{{ item.email }}</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
			</div>

			<div class="dotted-input-container" *ngIf="!isReportVisible">
				<span>{{ labels.lbl_geral_motivo }}</span>
				<textarea
					class="textarea"
					[rows]="3"
					[value]="customDepartment.alteration"
					(input)="customDepartment.alteration = $event.target.value"
					>{{ customDepartment.alteration }}</textarea
				>
			</div>

			<div class="button-container">
				<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
				<div class="button" (click)="clearInputs(true)">{{ labels.lbl_gerar_novo_department }}</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdating || isDisabling }"
					*ngIf="this.isButtonVisible === 1"
					(click)="deleteDepartment(customDepartment.id)">
					{{ labels.lbl_geral_desativar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isDisabling"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdating || isDisabling }"
					*ngIf="this.isButtonVisible === 0"
					(click)="activeDepartment(customDepartment.id)">
					{{ labels.lbl_geral_ativar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isDisabling"></cpi-dot-bounce-loading-effect>
				</div>
				<div class="button" [ngClass]="{ disabled: isUpdating || isDisabling }" (click)="validateForm()" type="submit">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
				</div>
			</div>

			<div *ngIf="!isReportVisible">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_pesquisar }}</span>
					<input type="text" [(ngModel)]="searchTextReport" [placeholder]="labels.lbl_geral_pesquisar" (keyup)="searchReport()" />
				</div>
				<div class="table-container">
					<table>
						<thead>
							<tr>
								<th>{{ labels.lbl_geral_usuario }}</th>
								<th>{{ labels.lbl_bulletin_actions }}</th>
								<th>{{ labels.lbl_geral_motivo }}</th>
								<th>{{ labels.lbl_geral_data }}</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="filteredReport || filteredReport?.length === 0; else showAll">
								<tr class="select-bond" *ngFor="let item of filteredReport; let indexItem = index">
									<td class="ci-name" *ngIf="item.email" [title]="item.email">{{ item.email }}</td>
									<td class="ci-name" *ngIf="item.changes" [title]="item.changes">{{ item.changes }}</td>
									<td class="ci-name">
										<span *ngIf="item.alteration" [title]="item.alteration">{{ item.alteration }}</span>
									</td>
									<td>{{ item.date_time }}</td>
								</tr>
							</ng-container>
							<ng-template #showAll>
								<tr class="select-bond" *ngFor="let item of reportDepartmentoList; let indexItem = index">
									<td class="ci-name" *ngIf="item.email" [title]="item.email">{{ item.email }}</td>
									<td class="ci-name" *ngIf="item.changes" [title]="item.changes">{{ item.changes }}</td>
									<td class="ci-name">
										<span *ngIf="item.alteration" [title]="item.alteration">{{ item.alteration }}</span>
									</td>
									<td>{{ item.date_time }}</td>
								</tr>
							</ng-template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	class="mt-2 ml-2"
	[color]="'var(--primary-color-1)'"
	*ngIf="isLoadingLabels || isLoadingDepartment"></cpi-dot-bounce-loading-effect>
